import * as API from '_axios'
import {ADMIN_URLS} from 'constants/url'

export const getAllFlags = async ({queryKey}) => {
    const [, pageNo] = queryKey
    const result = await API.post(
        `${ADMIN_URLS.getFlags}?pageNo=${pageNo || 0}`
    )
    return result
}

export const getFlagsById = async ({queryKey}) => {
    const [, id] = queryKey
    const result = await API.get(`${ADMIN_URLS.getFlags}/${id}`)
    return result
}
